// DuplicateDecisionModal.tsx
import React, { useRef, useContext } from "react";
import "./styles/DuplicateModal.css";
const alertIcon = require("../ManagePrepaidCustomers/components/images/alert.svg");
import { PhotoManagerContext } from "../PhotoManager/components";
import { usePopupClickOutside } from "../../hooks/usePopupClickOutside";

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
};

export default function DuplicateDecisionModal({ onConfirm, onCancel }: Props) {
  const popupRef = useRef<HTMLDivElement>(null);
  usePopupClickOutside(popupRef, () => onCancel());
  const context = useContext(PhotoManagerContext);

  return (
    <div>
      <div
        id="filter-dialog"
        className="modal fade in geo-modal geo-modal--small geo-modal--show uploader-modal duplicates-modal"
        style={{
          overflow: "unset",
          zIndex: context?.isMobile ? "1000001" : "1055"
        }}
        role="dialog"
      >
        <div className="modal-dialog filter-dialog-content" ref={popupRef}>
          <div className="modal-content">
            <div className="modal-header">
              &nbsp;
              <button
                type="button"
                className="close confirm-close"
                onClick={() => onCancel()}
              >
                <span>&times;</span>
              </button>
            </div>
            <div className="geo-modal__header geo-modal--warning-bg">
              <img
                className="geo-modal__warn-icon"
                src={alertIcon}
                alt="exclamation-warn"
              />
              <h3>Duplicate Files Found</h3>
            </div>
            <div className="modal-body">
              <span>
                Looks like some photos selected have already been uploaded
              </span>
            </div>
            <div className="modal-footer geo-modal__actions dont-break duplicates-footer">
              <button
                className="geo-btn geo-btn--link geo-btn--caps "
                onClick={onCancel}
              >
                Upload anyway
              </button>
              <button
                className="geo-btn geo-btn--secondary geo-btn--caps"
                onClick={onConfirm}
              >
                Skip duplicates
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal-backdrop fade in"
        style={{ zIndex: context?.isMobile ? "1000000" : "1054" }}
      />
    </div>
  );
}
